import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";

interface BillsOverviewCardProps {
  data?: {
    totalBills?: number;
    actualBills?: number;
    estimatedBills?: number;
    failedBills?: number;
    excludedConsumers?: number;
  };
}

export const BillsOverviewCard = ({ data }: BillsOverviewCardProps) => {
  const stats = [
    {
      label: "Total Bills",
      value: data?.totalBills ?? 0,
      color: "text-gray-900",
    },
    {
      label: "Actual Bills",
      value: data?.actualBills ?? 0,
      color: "text-blue-600",
    },
    {
      label: "Estimated Bills",
      value: data?.estimatedBills ?? 0,
      color: "text-gray-900",
    },
    {
      label: "Failed Bills",
      value: data?.failedBills ?? 0,
      color: "text-red-600",
    },
    {
      label: "Excluded Consumers",
      value: data?.excludedConsumers ?? 0,
      color: "text-gray-900",
    },
  ];

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-semibold text-gray-900">
          Bills Overview
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="divide-y divide-gray-100">
          {stats.map((stat, index) => (
            <div key={index} className="flex items-center justify-between py-1.5">
              <span className="text-sm font-medium text-gray-700">
                {stat.label}
              </span>
              <span className={`text-base font-bold ${stat.color}`}>
                {stat.value}
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
